export default __webpack_public_path__ + "static/media/acceX.bc13a898.svg";